import { View } from 'react-native';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import constants, { isPatientApp } from '@/config/constants';
import { Section } from '../AboutNeolexon/Section';

export const AccountDelete = () => {
  return (
    <View className="w-full p-4">
      <Text className="text-xl mb-4">
        Wenn Sie die vollständige und unwiderrufliche Löschung aller Ihrer bei
        uns gespeicherten Daten und Ihres gesamten Benutzerkontos wünschen,
        bestätigen Sie dies bitte mit dem Klick auf „unwiderruflich löschen“.
        Bitte beachten Sie, dass diese Löschung nicht wieder rückgängig gemacht
        werden kann. Falls Sie dies wünschen, können Sie vor der Löschung Ihre
        Daten
        <TextLink href={`${constants.address}/settings/export`}>
          <Text className="font-semibold text-blue-500"> hier </Text>
        </TextLink>
        unter Mein Account exportieren und abspeichern.
      </Text>
      {isPatientApp && (
        <Section
          title="Bitte beachten Sie:"
          content="Ihr:e Therapeut:in hat evtl. im Therapeuten-Account noch persönliche Daten über Sie gespeichert. Diese Daten (z.B. Profil mit Ihrem
            Namen, Geburtsdatum, Diagnose, individuelles Übungsmaterial) wurden
            im Therapeuten-Account angelegt, um Ihr Eigentraining einzustellen.
            Diese Daten werden nicht von uns gelöscht. Wenn Sie die Löschung
            dieser Daten wünschen, wenden Sie sich bitte an Ihre:n Therapeut:in."
        />
      )}
    </View>
  );
};
